<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <div class="aggreeWrap" v-html="content">
      </div>
      <div class="checkStyle">
        <el-checkbox
          v-model="checked"
        >我已同意签署《订单商品销售协议》</el-checkbox>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          :disabled="btnDisable"
          @click="goNext"
        >确 定{{ text }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
/*global protocol util http*/
import { mapGetters } from 'vuex'
export default {
  name: 'AgreementDialog',
  data() {
    return {
      btnDisable: true,
      time: 15,
      text: '15s',
      checked: true,
      timeer: null,
      dialogVisible: false,
      APP_COMPANY_NAME: window.g.APP_COMPANY_NAME,
      APP_COMPANYNAME_AB: window.g.APP_COMPANYNAME_AB,
      APP_PROVINCE_CITY: window.g.APP_PROVINCE_CITY,
      content: ``
    }
  },
  // commFormData --- localStorage里面
  // item --- vuex商品信息
  // setAnalogueMobileMes --- vuex里的数据，对手方账号
  computed: {
    ...mapGetters([
      'item',
      'setAnalogueMobileMes',
      'sessionInfoGetter',
      'systemTimeGetter'
    ])
  },
  mounted() {},
  methods: {
    getData() {
      const that = this
      this.timeer = window.setInterval(function() {
        if (parseInt(that.time) > 1) {
          that.text = Number(that.time) - 1 + 's'
          that.time--
        } else {
          that.text = null
          that.btnDisable = false
          window.clearInterval(that.timeer)
        }
      }, 1000)
    },
    showDialog(type) {
      this.dialogVisible = true
      window.clearInterval(this.timeer)
      this.timmer = null
      this.time = 15
      this.btnDisable = true
      const commName = localStorage.getItem('commName') || '' // 商品名称
      const commPrice = localStorage.getItem('commFormPrice') || '' // 商品单价
      const commNum = localStorage.getItem('commFormNum') || '' // 商品数量
      const commLydj = localStorage.getItem('commFormDj') || '' // 履约定金
      let buyName = '' // 买方
      let sellName = '' // 卖方
      const hideName = (name) => {
        // 将姓名按空格拆分成数组
        const nameArray = name.split(' ')
        // 遍历数组，将每个名字的第一个字母保留，其余字母替换为 "*"
        for (let i = 0; i < nameArray.length; i++) {
          if (nameArray[i].length > 1) {
            nameArray[i] = nameArray[i][0] + '*'.repeat(nameArray[i].length - 1)
          }
        }

        // 将数组中的名字用空格连接起来并返回
        return nameArray.join(' ')
      }
      protocol.param_tq_queryTopUserName.param.bsFlag = type == 1 ? 'B' : 'S'
      protocol.param_tq_queryTopUserName.param.commodityId = this.item.symbolId
      http.postFront(protocol.param_tq_queryTopUserName).then((response) => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (type == 1) {
            buyName = hideName(localStorage.getItem('userName'))
            sellName = hideName(value || '')
            // }
          } else {
            sellName = hideName(localStorage.getItem('userName'))
            buyName = hideName(value || '')
          }
          protocol.param_getContentDetails.param.id = 596
          http.getRes(protocol.param_getContentDetails).then(response => {
            const { code, message, value } = response.data
            if (code === 0 || code === '0') {
              const systemTimeGetter = util.dateDayFormate(this.systemTimeGetter)
              const obj = { commName, commPrice, commNum, commLydj, buyName, sellName, systemTimeGetter }
              this.content = value.content.replace(/\$\{(.*?)\}/g, function(val, key) {
                return obj[key]
              })
              // this.content = value.content
              //   .replace(/\$\{commName\}/g, commName)
              //   .replace(/\$\{commPrice\}/g, commPrice)
              //   .replace(/\$\{commNum\}/g, commNum)
              //   .replace(/\$\{commLydj\}/g, commLydj)
              //   .replace(/\$\{buyName\}/g, buyName)
              //   .replace(/\$\{sellName\}/g, sellName)
              //   .replace(/\$\{systemTimeGetter\}/g, util.dateDayFormate(this.systemTimeGetter))
            } else {
              this.$toast(message)
            }
          })
          this.getData()
        } else {
          this.$message(message)
        }
      })
    },
    repeatString(str, n) {
      return new Array(n + 1).join(str)
    },
    goNext() {
      if (this.checked) {
        this.dialogVisible = false
        this.$emit('reLoad')
      } else {
        this.$message('请先勾选协议！')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog {
  width: 1200px !important;
  height: initial !important;
  border-radius: 8px;
  margin-top: 7vh !important;
  .aggreeWrap {
    height: 594px;
    overflow-y: scroll;
    p {
      font-weight: 500;
      color: #d4d4d4;
      font-size: 16px;
      line-height: 26px;
      margin-right: 20px;
    }
  }
  .checkStyle {
    padding-top: 10px;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    font-weight: 600;
    color: #d4d4d4;
    font-size: 16px;
  }
  .el-dialog__body {
    padding: 0 40px;
  }
  .el-dialog__header {
    text-align: center !important;
    background-color: #2c2c2c !important;
    padding: 40px 40px 0 40px !important;
    border-radius: 8px 8px 0 0;
  }
  .el-dialog__body {
    background-color: #2C2C2C !important;
  }
  .el-dialog__headerbtn {
    top: 20px;
    right: 40px;
  }
  .el-dialog__footer {
     background-color: #2C2C2C !important;
    text-align: center;
    padding: 40px;
    border-radius: 0 0 8px 8px;
  }
  .el-button + .el-button {
    margin-left: 25px;
  }
  .el-button {
    padding: 10px 34px;
  }
  /*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/

  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    background-color: transparent;
  }
  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px #dfdfdf;
    border-radius: 10px;
    background-color: transparent;
  }
  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px #838383;
    background-color: #383f66;
  }
  .el-button--primary {
    span {
      color: #fff;
    }
  }
}
</style>
